import { Stack, styled } from '@mui/material';

/** Below this list width the Actions key hint drops, so the bar still fits a split-view list. */
export const BULK_OVERLAY_HINT_MIN_WIDTH = '30rem';

/**
 * Floats the bulk job banner and the selection bar over the bottom of the list panel that owns
 * the selection, centred on that panel rather than the window. The banner stacks above the bar.
 */
export const BulkOverlay = styled(Stack, { name: 'BulkOverlay' })(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: '0.75rem',
  zIndex: theme.zIndex.app.ServiceDeskChatComposer,
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0 0.75rem',
  containerType: 'inline-size',
  pointerEvents: 'none',
  '& > *': { pointerEvents: 'auto', maxWidth: '100%' },
}));
